import React from "react";
import {
  editorsChoice,
  background,
  crow,
  ring,
} from "./editorschoice.module.scss";

const EditorsChoice = () => (
  <svg
    className={editorsChoice}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 177.64 177.64"
  >
    <circle className={background} cx="88.82" cy="88.82" r="88.82" />
    {/* <circle cx="88.82" cy="88.82" r="59.26"/> */}
    <text transform="scale(-1) rotate(-71.04 -53.9 -15.28)">
      <tspan x="0" y="0" fontSize="14.86">
        T
      </tspan>
      <tspan x="10.21" y="-.07" fontSize="14.86" rotate="-8.7">
        H
      </tspan>
      <tspan x="21.35" y="-1.94" fontSize="14.86" rotate="-16.92">
        E
      </tspan>
      <tspan x="29.94" y="-4.7" fontSize="14.86" rotate="-22.04">
        {" "}
      </tspan>
      <tspan x="33.7" y="-6.15" fontSize="14.86" rotate="-27.11">
        C
      </tspan>
      <tspan x="42.13" y="-10.54" fontSize="14.86" rotate="-35.19">
        R
      </tspan>
      <tspan x="50.64" y="-16.6" fontSize="14.86" rotate="-43.86">
        O
      </tspan>
      <tspan x="59.35" y="-24.92" fontSize="14.86" rotate="-55.24">
        W
      </tspan>
      <tspan x="68.13" y="-38.44" fontSize="14.86" rotate="-63.66">
        ’
      </tspan>
      <tspan x="70.25" y="-42.61" fontSize="14.86" rotate="-68.83">
        S
      </tspan>
      <tspan x="73.17" y="-50.5" fontSize="14.86" rotate="-73.76">
        {" "}
      </tspan>
      <tspan x="74.46" y="-54.48" fontSize="14.86" rotate="-79.8">
        N
      </tspan>
      <tspan x="76.33" y="-65.83" fontSize="14.86" rotate="-88.19">
        E
      </tspan>
      <tspan x="76.53" y="-75.18" fontSize="14.86" rotate="-95.42">
        S
      </tspan>
      <tspan x="75.66" y="-83.93" fontSize="14.86" rotate="-102.8">
        T
      </tspan>
      <tspan x="73.41" y="-93.09" fontSize="14.86" rotate="-108.03">
        {" "}
      </tspan>
      <tspan x="72.25" y="-96.63" fontSize="14.86" rotate="-111.27">
        ·
      </tspan>
      <tspan x="70.43" y="-101.18" fontSize="14.86" rotate="-114.89">
        {" "}
      </tspan>
      <tspan x="68.54" y="-105.39" fontSize="14.86" rotate="-120.53">
        E
      </tspan>
      <tspan x="63.67" y="-113.56" fontSize="14.86" rotate="-128.72">
        D
      </tspan>
      <tspan x="56.81" y="-121.78" fontSize="14.86" rotate="-134.99">
        I
      </tspan>
      <tspan x="52.95" y="-125.7" fontSize="14.86" rotate="-141.17">
        T
      </tspan>
      <tspan x="45.15" y="-131.92" fontSize="14.86" rotate="-149.67">
        O
      </tspan>
      <tspan x="35.58" y="-137.41" fontSize="14.86" rotate="-158.04">
        R
      </tspan>
      <tspan x="25.98" y="-141.15" fontSize="14.86" rotate="-165.52">
        S
      </tspan>
      <tspan x="17.75" y="-143.15" fontSize="14.86" rotate="-170.75">
        ’
      </tspan>
      <tspan x="13.48" y="-143.82" fontSize="14.86" rotate="-173.95">
        {" "}
      </tspan>
      <tspan x="9.47" y="-144.31" fontSize="14.86" rotate="-179.07">
        C
      </tspan>
      <tspan x="-.37" y="-144.41" fontSize="14.86" rotate="172.29">
        H
      </tspan>
      <tspan x="-11.4" y="-142.83" fontSize="14.86" rotate="163.42">
        O
      </tspan>
      <tspan x="-22.01" y="-139.44" fontSize="14.86" rotate="157.07">
        I
      </tspan>
      <tspan x="-26.56" y="-137.57" fontSize="14.86" rotate="151.61">
        C
      </tspan>
      <tspan x="-35.09" y="-132.84" fontSize="14.86" rotate="143.76">
        E
      </tspan>
    </text>
    <path
      className={crow}
      d="M115.77 96.75zm13.75 6.45l-.09 2.27a.1.1 0 01-.1.1l-.8-.03-.4 10.64.79.03c.05 0 .1.05.1.1l-.1 2.28a.1.1 0 01-.1.1l-.32-.02-.39.79-10.15-.4-.28-.81a.1.1 0 01-.1-.1l.09-2.28c0-.05.05-.1.1-.09l.68.03.1-3.1-2.13-.09-.12 3.11.8.03c.05 0 .09.05.09.1l-.1 2.28a.1.1 0 01-.1.1l-.32-.02-.38.79-10.16-.4-.28-.81a.1.1 0 01-.1-.1l.1-2.27c0-.06.04-.1.1-.1l.66.03.05-1.3h-1.54v14.6h-.47v.55h-4.49v-.54h-.3l-1.07-9.19-.62-.61v-.82h-.97a.43.43 0 01-.44-.43v-1.67h-.83l.04 2.67h-2.08v-.57h-.65v1.1c0 .1-.08.19-.18.19h-.37a.18.18 0 01-.18-.18v-1.1h-.85v1.1c0 .1-.08.18-.18.18h-.37a.18.18 0 01-.18-.18v-1.1h-.94v1.1c0 .1-.08.18-.18.18h-.37a.18.18 0 01-.18-.18v-1.1h-.94v1.1c0 .1-.09.18-.18.18h-.38a.18.18 0 01-.18-.18v-1.1h-.87v1.1c0 .1-.08.18-.18.18h-.37a.18.18 0 01-.19-.18v-1.1h-.8v1.1c0 .1-.09.18-.19.18h-.37a.18.18 0 01-.18-.18v-1.1h-.68v.56h-2.07v-2.64h-.9v1.64c0 .24-.2.43-.43.43h-.47v.82l-.63.61-1.06 9.19h-.3v.54H73.4v-.54h-.47v-14.58H70.8l-.03-.98h2.16v-1.17l-2.14.22h-.05l.1 3.25.8-.03c.06 0 .1.04.1.1l.08 2.27a.1.1 0 01-.1.1l-.31.01-.33.82-10.16.35-.34-.8a.1.1 0 01-.1-.09l-.08-2.27c0-.05.04-.1.1-.1l.66-.02-.11-3.22-2.12.07.01.48-.01.03.1 2.72.79-.03c.05 0 .1.04.1.1l.08 2.27a.1.1 0 01-.1.1l-.32.01-.32.82-10.16.35-.34-.8a.1.1 0 01-.1-.09l-.08-2.27c0-.05.04-.1.1-.1l.64-.02-.35-10.65-.67.03a.1.1 0 01-.1-.1l-.08-2.27c0-.05.04-.1.1-.1l.35-.01a.1.1 0 01-.12-.1l-.01-.46a.1.1 0 01.1-.1l.32-.02-.18-5.16c-.01-.32-.03-.9.44-1.03v-.01l-.16-4.4c0-.08.07-.15.16-.16.09 0 .16.07.16.16l.15 4.39v.01c.48.07.5.53.51 1l.08 2.31 7.17-.25-.08-2.3c-.01-.33-.03-.92.44-1.04v-.01l-.16-4.4c0-.08.07-.15.15-.16.1 0 .16.07.17.16l.15 4.39c.47.07.5.54.5 1.01l.19 5.16.3-.01a.1.1 0 01.12.1l.02.45a.1.1 0 01-.1.11l.47-.02c.06 0 .1.04.1.1l.09 2.27a.1.1 0 01-.1.1l-.8.03.09 2.38h.01l.04 1.07 2.12-.07-.12-3.47-.66.03a.1.1 0 01-.1-.1l-.08-2.27c0-.05.04-.1.1-.1l.34-.01a.1.1 0 01-.11-.1l-.02-.45a.1.1 0 01.1-.12h.32l-.18-5.17c0-.31-.03-.9.45-1.03v-.01l-.16-4.4c0-.08.06-.15.15-.15s.16.06.16.15l.16 4.39v.01c.47.07.49.53.5 1-.07 0-.03 0 0 0 .04.01.08.01 0 .02l.08 2.3 7.17-.25-.08-2.32c-.01-.31-.03-.9.44-1.03v-.01l-.16-4.4c0-.08.07-.15.16-.15s.16.06.16.15l.15 4.39v.01c.48.07.5.53.51 1l.18 5.16.31-.01a.1.1 0 01.11.1l.02.45a.1.1 0 01-.1.11l.48-.02c.05 0 .1.05.1.1l.08 2.27a.1.1 0 01-.1.1l-.8.03.06 1.41h.04l2.91-.23v-4.8c0-.25.2-.44.43-.44h6.44c.24 0 .43.2.43.43v.5c.16-.15.28-.3.32-.47.18-.65-.22-.9 0-1.22.18-.26.55-.29.77-.28l.01-4.2-.42-2.2.18-6.62-2.13-3.37-.34-7.71s-.2-.48.17-.63c.25-.1 1.73-.33 2.62-.47v-.06S80.79 63.4 80.79 58.2c0-12.94 1.35-22.68 1.35-22.68s1.85-11.63 5.43-23.76h2.57c3.27 11.07 5.5 23.73 5.5 23.73s1.31 11.32 1.31 22.68c0 5.44-1.12 15.33-1.23 16.25.98.17 2.38.43 2.61.52.36.15.17.63.17.63l-.34 7.7L96 86.66l.16 6.63-.35 2.19-.03 2.63c.22 0 .5.06.65.28.23.32-.17.58 0 1.22.1.37.58.69 1.05 1.1h6.15c.24 0 .43.2.43.44v4.78l2.9.23.06-1.43-.66-.03a.1.1 0 01-.1-.1l.1-2.27c0-.05.04-.1.1-.1l.35.02a.1.1 0 01-.1-.11v-.45c.01-.06.06-.1.12-.1h.31l.2-5.15c.02-.32.04-.9.52-1v-.01l.17-4.4c0-.08.07-.14.16-.14s.16.07.15.16l-.17 4.39v.01c.47.1.45.57.44 1.04l-.1 2.3 7.17.29.1-2.31h.03-.04c.01-.32.04-.91.52-1v-.01l.16-4.4c0-.08.08-.14.16-.14.1 0 .16.07.16.16l-.17 4.39v.01c.47.1.45.57.43 1.04l-.2 5.15.31.01c.06 0 .11.06.1.12v.44a.1.1 0 01-.12.1l.48.03c.05 0 .1.05.1.1l-.1 2.27a.1.1 0 01-.1.1l-.79-.04-.14 3.58 2.14.08.14-3.58-.67-.03a.1.1 0 01-.09-.1l.09-2.27c0-.06.05-.1.1-.1l.35.02a.1.1 0 01-.1-.12l.01-.44c0-.06.05-.11.11-.1h.32l.2-5.15c.01-.32.04-.91.51-1v-.01l.17-4.4c0-.08.08-.14.16-.14.1 0 .16.07.16.16l-.17 4.39v.01c.46.1.45.57.43 1.04l-.1 2.3 7.17.29.1-2.31c0-.32.03-.91.51-1v-.02l.17-4.39c0-.08.07-.15.15-.15h.01c.09 0 .15.08.15.17l-.17 4.38v.02c.47.1.45.57.43 1.03l-.2 5.16.32.01c.06 0 .1.06.1.12l-.02.44a.1.1 0 01-.1.1l.47.03c.06 0 .1.04.1.1zm-56.6 7.1h-.44c-.06 0-.1-.1-.13-.25h-.75l-.04.4h-.88l.03.85 2.22-.22v-.78zm.56-3.49l-2.82.22-.1.01.02.64h.98l.04.32h.78c.05-.4.1-.65.2-.7.14-.1.9 0 .9 0v-.49zm8.2 6.8v-3.95h-.9v.64s.54-.12.54.97c0 1.12-.54 1.04-.54 1.04v1.3h.9zm.17-5.74h-1.07v.9h.96l.1-.7v-.2zm0-1.85c-.12.02-.58.07-1.07.01v1.02h1.07v-1.03zm.01-4.4c-.02.08-.06.16-.1.24-.11.2-.55.48-.98.86v1.26l1.08.01v-2.36zm14.9 8.01h-.9l.04 3.96h.86v-1.31c-.15-.02-.54-.14-.54-1.04 0-.88.39-.97.54-.98v-.63zm0-1.79H95.7l-.02.38.12.52h.97v-.9zm0-1.89H95.7l-.02 1.06h1.08v-1.06zm0-4.8c-.43-.37-.87-.66-.98-.86l-.02-.04-.04 3.45.47-.01c.18 0 .38-.03.57-.08v-2.45zm9.97 10.97l-1.61-.1v1.06h1.58l.03-.95zm.06-1.55h-.55l-.06-.55h-.87c-.03.17-.08.28-.14.28h-.05v.86l1.65.1.03-.7zm.14-3.56a.7.7 0 01-.05-.01l-2.82-.22v.52s.88-.1 1.02 0c.09.05.14.28.19.67h.94l.03-.17h.66l.03-.8z"
    />
    <path
      className={ring}
      d="M101.66 40.73a49.86 49.86 0 0136.94 48.1c0 7.55-1.7 14.72-4.73 21.14l.6 7.26a53.79 53.79 0 00-33.2-80.73c.1 1.03.24 2.47.39 4.23zM123.2 124.77a49.59 49.59 0 01-34.38 13.83 49.6 49.6 0 01-34.38-13.83l-5.46.17a53.64 53.64 0 0039.84 17.66c15.8 0 30.02-6.82 39.86-17.67-.19.01-5.48-.16-5.48-.16zM43.6 109.59a49.46 49.46 0 01-4.56-20.77 49.86 49.86 0 0137-48.1c.16-1.8.31-3.22.43-4.23a53.79 53.79 0 00-33.37 80.65l.5-7.55z"
    />
  </svg>
);

export default EditorsChoice;
